import { select, takeEvery, call, put } from 'redux-saga/effects'
import { startSubmit, change, stopSubmit, getFormNames } from 'redux-form/immutable'
import { uploadImageRequest } from '../actions'
import { promisedCanvasToBlob } from 'helpers/promises/promisedCanvasToBlob'
import { uploadFileToS3 } from 'store/entities/api/sagas/s3PolicySagas'
import { showError } from 'store/entities/toastr/utils'

export default function* uploadProtrackImagesSaga() {
  yield takeEvery(uploadImageRequest.toString(), handleUploadProtrackImages)
}

export function* handleUploadProtrackImages({ payload: { file, mime, ext, fileFieldName } }) {
  // find better solution to understand form name
  const formName = (yield select(getFormNames())).toJS()[0]
  yield put(startSubmit(formName))
  try {
    let imagePath
    if (file instanceof HTMLCanvasElement) {
      const blob = yield call(promisedCanvasToBlob, file, mime)
      imagePath = yield call(uploadImageToS3, blob, ext)
    } else {
      imagePath = yield call(uploadImageToS3, file, file.name.substring(file.name.lastIndexOf('.') + 1))
    }
    yield put(change(formName, fileFieldName, imagePath))
  } catch (error) {
    showError()
  } finally {
    yield put(stopSubmit(formName))
  }
}

export function* uploadImageToS3(file, ext) {
  return yield call(uploadFileToS3, { file, ext, entity: 'protracks' })
}
